import React, { useEffect, useRef } from "react";
import ConnectRepository from "../components/ConnectRepository";
import ScanAnimation from "../components/ScanAnimation";
import { useScan } from "../contexts/ScanContext";
import { useNavigate } from "react-router-dom";
import { getGuestToken, guestResultsPath } from "../utils/guestScans";

const ScanPage = () => {
  const { analyzing, scanId, error, user } = useScan();
  const navigate = useNavigate();
  // Only a scan started from this page leads to results; a stale scanId left in context
  // (e.g. after "Scan Another Repository") must not.
  const startedHere = useRef(false);

  useEffect(() => {
    if (analyzing) startedHere.current = true;
    // When analysis is finished, and there's no error, navigate to the results page.
    if (startedHere.current && !analyzing && scanId && !error) {
      // A guest scan's link carries its access token, so it can be bookmarked or shared.
      navigate(user ? `/results/${scanId}` : guestResultsPath(scanId, getGuestToken(scanId)));
    }
  }, [analyzing, scanId, error, user, navigate]);

  // Show scanning animation when analyzing is true
  if (analyzing) {
    return <ScanAnimation />;
  }

  // Otherwise show the repository connection screen
  return <ConnectRepository />;
};

export default ScanPage;